import httpClient from '../../httpClient';

export const getAllScaleDevices = () => {
  return httpClient({
    method: "GET",
    url: "/super-admin/scaleDevices/all",
  });
};

export const registerNewScaleDevice = (data) => {
  return httpClient({
    method: "POST",
    url: "/super-admin/scaleDevices/register",
    data,
  });
};

export const getIndividualScaleDevice = (id) => {
  return httpClient({
    method: "GET",
    url: `/super-admin/scaleDevices/${id}`,
  });
}

export const assignScaleDeviceToStore = (id, data) => {
  return httpClient({
    method: "POST",
    url: `/super-admin/scaleDevices/${id}/store/attach`,
    data,
  });
}

export const searchScaleDevices = (searchInput) => {
  return httpClient({
    method: "GET",
    url: "/super-admin/scaleDevices/all/search",
    params: {
      searchTerm: searchInput,
    },
  });
}
